import React from 'react';

import { isAuthenticated, login } from "@seims/shared/src/security";
import {HomeView} from '../components/home/HomeView';
import CreateCandidate from '../components/nyscandidate/CandidateDetailsView';

export const ToggleHomeView = () => (isAuthenticated())
    ? <CreateCandidate />
    : <HomeView />
;

export const handleLogin = async () => {
    login({
        redirectUri: `${window.location.origin}/my-dashboard`
    });
};
